import { useEffect } from "react";

// WhatsApp community group link
const COMMUNITY_URL = "https://chat.whatsapp.com/JxkaG8PAWl62gzPvgMedLL";

// NOTE: Primary fast redirect happens in /public/index.html via inline script
// (runs BEFORE React loads). This component is a fallback and ONLY fires
// inside its own render — never at module import time.
export default function JoinCommunityPage() {
  useEffect(() => {
    // Fire Meta Pixel custom event (best-effort, non-blocking)
    try {
      if (typeof window !== "undefined" && window.fbq) {
        window.fbq("trackCustom", "JoinCommunity", { source: "whatsapp_template" });
      }
    } catch (_e) {
      // noop
    }
    // Immediate redirect (no delay)
    window.location.replace(COMMUNITY_URL);
  }, []);

  return (
    <div
      data-testid="join-community-page"
      className="min-h-screen flex items-center justify-center bg-[#0B1220] text-white px-6"
      style={{ fontFamily: "Manrope, sans-serif" }}
    >
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold">Opening WhatsApp…</h1>
        <a
          href={COMMUNITY_URL}
          data-testid="join-community-manual-link"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0B1220] font-bold transition-colors"
        >
          Open WhatsApp Group
        </a>
      </div>
    </div>
  );
}
